import { Col, Row } from 'react-bootstrap';

type PatientInfoRowProps = {
  label: string;
  value?: string;
  dataTest: string;
};

export default function PatientInfoRow({
  label,
  value,
  dataTest,
}: PatientInfoRowProps) {
  return (
    <Row>
      <Col>
        <span className="fw-medium">{label}</span>
      </Col>
      <Col>
        <span data-test={dataTest}>{value}</span>
      </Col>
    </Row>
  );
}
